import { PastAction } from "../views/app/challenge/ChallengeView.interface";

type PastPendingActions = {
  pendingTitle: string;
  pendingDescription: string;
  actionsCounts: number;
  actions: Array<PastAction>;
  missedAllLabel: string;
  submitDoneLabel: string;
  actionLabel: string;
  doneLabel: string;
};
interface GameNotifications {
  progress: Array<{
    progressTitle: string;
    progressType: "zenPoints" | "streak";
    progressPoints: string;
    progressSummary: string;
    progressDismissLabel: string;
  }>;
  achievements: Array<{
    achievementTitle: string;
    achievementDescription: string;
    achievementImg: string;
    bonus: string;
  }>;
  pastPendingActions: PastPendingActions;
}

const initialGameNotificationsState: GameNotifications = {
  progress: [],
  achievements: [],
  pastPendingActions: null,
};

export { GameNotifications, initialGameNotificationsState, PastPendingActions };
